export default __webpack_public_path__ + "static/media/Mark-3-Suit-Cycles-13.ee097ee0.jpg";